import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
interface EvidenceInteractiveProps {
  accent: string;
}
const NODES = [{
  id: 'population',
  label: 'Population',
  detail: 'Women undergoing controlled ovarian stimulation for IVF/ICSI. [Insert approved inclusion criteria] [Ref]',
  locked: false
}, {
  id: 'randomisation',
  label: 'Randomisation',
  detail: 'Randomised, controlled trial design. [Confirm approved design wording] [Ref]',
  locked: false
}, {
  id: 'armA',
  label: 'REKOVELLE',
  detail: 'Daily dose individualised using AMH and body weight. [Ref]',
  locked: false
}, {
  id: 'armB',
  label: 'Follitropin alfa',
  detail: 'Conventional dosing as defined in the study protocol. [Ref]',
  locked: false
}, {
  id: 'endpoints',
  label: 'Endpoints',
  detail: '[Insert approved primary and key secondary endpoints with results]',
  locked: true
}];
export function EvidenceInteractive({
  accent
}: EvidenceInteractiveProps) {
  const [active, setActive] = useState('population');
  const node = NODES.find(n => n.id === active) ?? NODES[0];
  const Node = ({
    id,
    wide = false
  }: {
    id: string;
    wide?: boolean;
  }) => {
    const n = NODES.find(x => x.id === id);
    if (!n) return null;
    const on = active === id;
    return <button type="button" onClick={() => setActive(id)} aria-pressed={on} className={`flex items-center justify-center gap-1.5 rounded-2xl border px-3 py-3 text-[13px] font-medium transition focus:outline-none focus-visible:ring-2 focus-visible:ring-pulse-iris ${wide ? 'w-full' : ''}`} style={{
      borderColor: on ? accent : 'rgba(15,36,66,0.1)',
      backgroundColor: on ? `${accent}14` : '#FFFFFF',
      color: '#0F2442'
    }} data-id="element-168" data-mp="3ebtgkapgshm4">
        {n.locked && <LockIcon className="h-3.5 w-3.5 text-slate-400" data-id="element-169" data-mp="onj66bkgf0bb" />}
        {n.label}
      </button>;
  };
  const Connector = () => <span className="h-px w-6 shrink-0 bg-navy-900/20" aria-hidden="true" data-id="element-170" data-mp="tkt2mb69gc8n" />;
  return <div data-id="element-171" data-mp="s605588cqo2i">
      <div className="flex items-center" data-id="element-172" data-mp="s5qf5knb4gwt">
        <div className="w-[120px] shrink-0" data-id="element-173" data-mp="n5lxhranxg50"><Node id="population" wide data-id="element-174" data-mp="n4j67i9fhbok" /></div>
        <Connector data-id="element-175" data-mp="n7oremexrtf0" />
        <div className="w-[130px] shrink-0" data-id="element-176" data-mp="i5pplgyuh4k6"><Node id="randomisation" wide data-id="element-177" data-mp="i70ujk410icv" /></div>
        <Connector data-id="element-178" data-mp="d7641ho5xusc" />
        <div className="flex w-[150px] shrink-0 flex-col gap-2" data-id="element-179" data-mp="d7o5cspomz74">
          <Node id="armA" wide data-id="element-180" data-mp="d9it0esc95ew" />
          <Node id="armB" wide data-id="element-181" data-mp="1avg59ug4keie" />
        </div>
        <Connector data-id="element-182" data-mp="1au51humoj6ra" />
        <div className="min-w-0 flex-1" data-id="element-183" data-mp="1awr91u9klm9i"><Node id="endpoints" wide data-id="element-184" data-mp="15vad8d5y0pzs" /></div>
      </div>

      <motion.div key={node.id} initial={{
      opacity: 0,
      y: 8
    }} animate={{
      opacity: 1,
      y: 0
    }} className={`mt-5 rounded-2xl p-5 ${node.locked ? 'border border-dashed border-navy-900/20 bg-mist-50' : 'bg-white'}`} data-id="element-185" data-mp="15xwsz02zmbt3">
        <p className="text-[11px] font-semibold uppercase tracking-[0.16em]" style={{
        color: accent
      }} data-id="element-186" data-mp="1tlo2xx122cr7">
          {node.label}
        </p>
        <p className={`mt-2 text-[15px] leading-relaxed ${node.locked ? 'text-slate-500' : 'text-navy-900'}`} data-id="element-187" data-mp="1otd5r1xp952c">{node.detail}</p>
        {node.locked && <p className="mt-2 text-[11px] text-slate-400" data-id="element-188" data-mp="2145j2m3fspt5">Approved clinical data will be inserted after medical review.</p>}
      </motion.div>
    </div>;
}